import { Hook } from "@oclif/core"

const hook: Hook<"postrun"> = async function (_) {
  // if (Command && Command.prototype instanceof BaseCommand) {
  //   try {
  //     // @ts-expect-error TS-2351
  //     const cmd = new (Command as never)(argv, config)
  //     const { flags } = await cmd.parse(Command)
  //     cmd.saveConfig(flags)
  //     this.log("Configuration saved for future use in .supernova.json")
  //   } catch {
  //     console.log("Cannot apply configuration from .supernova.json")
  //   }
  // }
}

export default hook
